import { Component, Input, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { MapGoogleService } from 'src/app/services/map-google.service';
import { TaskTypeEnum } from 'src/enumerators';
import { Task } from 'src/models';

@Component({
  selector: 'app-task-info',
  templateUrl: './task-info.component.html',
  styleUrls: ['./task-info.component.css', '../info-window-dinamic.component.css']
})
export class TaskInfoComponent implements OnInit {

  @Input() task: Task;

  arrayFromActivities = [];
  addressTask = '';

  constructor(
    public _mapGoogleService: MapGoogleService
  ) { }

  ngOnInit() {
    this.addressTask = (this.task?.address?.road ? this.task?.address?.road + ', ' : '') +
      (this.task?.address?.road ? this.task?.address?.house_number ?
        this.task?.address?.house_number + ' - ' : 's/ nº - ' : '') +
      (this.task?.address?.suburb ? this.task?.address?.suburb + ', ' : '') +
      (this.task?.address?.city ? this.task?.address?.city : '') +
      (this.task?.address?.postcode ? (', ' + this.task?.address?.postcode) : '');

    for (let index = 0; index < this.task?.progress?.activities; index++) {
      this.arrayFromActivities.push(index);
    }
  }

  openTaskDetails() {
    this._mapGoogleService.sidebarMapOpen = true;
  }

  setTaskIcon(taskType): Object {
    return {
      'fa-square-plus': taskType == TaskTypeEnum.Implantation,
      'fa-square-x': taskType == TaskTypeEnum.Removal,
      'fa-brush': taskType == TaskTypeEnum.Maintenance,
      'fa-arrow-down-to-bracket': taskType == TaskTypeEnum.Cataloging,
      'fa-arrows-cross': taskType == TaskTypeEnum.Replacement,
    };
  }
}
